import React, { useState } from 'react'
import axios from 'axios'
export default function DietApi() {
  const [weight,Setweight] = useState('')
  const [data,Setdata] = useState('')
  const getDiet = ()=>{
    if((weight==='gain')||(weight==='Gain'))
    {
      try {
        axios.get('https://gym-upp-api.onrender.com/api/diet/').then((res)=>{
          console.log(res.data[1]);
          Setdata(res.data[1])
        })
       } catch (error) {
        console.log(error);
       }
      }
      else if((weight==='loss'||(weight==='Loss')))
      {
        try {
          axios.get('http://localhost:5000/api/diet/').then((res)=>{
            console.log(res.data[0]);
            Setdata(res.data[0])
          })
         } catch (error) {
          console.log(error);
         }
      }
      else 
      {
        alert('Please fill in correctly!')
      }
  //  try {
  //   axios.get('http://localhost:5000/api/diet/').then((res)=>{
  //     console.log(res.data[0]);
  //   })
  //  } catch (error) {
  //   console.log(error);
  //  }
  }
  return (
    <>
     <div className='bg-gradient-to-t from-[#3D0000] to-[#000000]  text-xl p-10 text-white font-[Roboto Condensed] pt-16 pb-16'>
    <p className=' text-4xl text-center pt-6'>"To keep the body in good health is a duty... otherwise, we shall not be able to keep the mind strong and clear."</p>
     <p className=' text-xl font-[Poppins] text-center pt-6 ml-4'>Fill in this form and we make a custom diet plan! </p>
    <div className=' lg:flex lg:justify-center lg:gap-72 border-black pt-16'>
    <div className=' flex flex-col justify-center gap-10 lg:gap-16 lg:pl-24 '>
        <input type="text" placeholder='Name' className=' p-3 outline-none bg-gray-500 text-xl font-[Poppins] rounded-3xl lg:w-full'/>
        <input type="number" placeholder='Age' className=' p-3 outline-none bg-gray-500 text-xl font-[Poppins] rounded-3xl'/>
        <input type="text" placeholder='Gender' className=' p-3 outline-none bg-gray-500 text-xl font-[Poppins] rounded-3xl'/>
        <input type="number" placeholder='Height(Cms)' className=' p-3 outline-none bg-gray-500 text-xl font-[Poppins] rounded-3xl'/>
        <input type="number" placeholder='Weight(kgs)' className=' p-3 outline-none bg-gray-500 text-xl font-[Poppins] rounded-3xl'/>
        <input type="text" placeholder='Weight loss or gain? ' className=' p-3 outline-none bg-gray-500 text-xl font-[Poppins] rounded-3xl' onChange={(e)=>{Setweight(e.target.value)}}/>
        <button className=' bg-[#da1010] px-5 py-2 w-full text-white text-lg rounded-full hover:bg-[#3D0000]  my-6 m' onClick={getDiet}> Get Diet </button>
    </div>
    <img src="https://images.unsplash.com/photo-1620706857370-e1b9770e8bb1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8bnV0cml0aW9ufGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60" alt="..." className=' rounded-[3.5rem] pt-16 lg:pt-0' />
   </div>
   <div className=' mt-16'>
    {data ? <> <div className=' bg-[#801f1f] h-full w-full mt-20 lg:mt-0 rounded-tr-[4rem] rounded-bl-[4rem] p-5 lg:m-8 '>
          <h1 className=' text-2xl py-6 font-[Poppins] text-center'>{data.Title}</h1>
          <p className=' text-xl pb-6 font-mono'>{data.Diet}</p>
          <p className=' text-xl pb-6 font-mono'>{data.Tips}</p>
      </div></>:<></>}
   </div>
   </div>
  </>
  )
}
